/* eslint-disable max-len */
export const DISHWASHER_ANIMATIONS = {
  FOUR_EASY_STEPS: 'https://dam.thdstatic.com/content/production/HCH7BLdVbBDlRaSKb4669g/zFblzMgkby-QRMCgmsQRkg/Original%20file/d29a-major-appliance-delivery-ux--first-page-animation-1224.gif',
  DELIVERY_PATH: 'https://dam.thdstatic.com/content/production/RtRYilfdoxbX3SftLUL24g/FrXgvgZNHSZWD8h4Nmd7hA/Original%20file/Step-1-Delivery-Path.gif',
  DISHWASHER_MEASURE_WIDTH: 'https://dam.thdstatic.com/content/production/cKYJz9NGEIvp3trqlAtfkg/SWBlai5UFwNBYTPSSVeB5g/Original%20file/Step-2-Dishwasher-Width.gif',
  DISHWASHER_MEASURE_HEIGHT: 'https://dam.thdstatic.com/content/production/uV9qy1E9oCRYsA_kBWwPbA/-CLHHPgVl9OFEri9Znwx_Q/Original%20file/Step-3-Dishwasher-Height.gif',
  DISHWASHER_MEASURE_DEPTH: 'https://dam.thdstatic.com/content/production/K14Gfsl4t8e16taGqqYIoA/osn-oVvfrFTGMjX5Iuxx2w/Original%20file/Step-4-Dishwasher-Depth.gif',
  DISHWASHER_DOOR_CHECK: 'https://dam.thdstatic.com/content/production/4hdjlq1caqMEwazXpZi7qw/I4py0UoyX1xbiL1VVvZ4ig/Original%20file/Step-4-Dishwasher-Door-Open.gif'
};

export const DISHWASHER_DRAWER_MAPPING = [
  // Page 1
  {
    header: 'Make Sure It Fits',
    sections: [
      {
        text: {
          id: 'text_0',
          string: 'Let\'s Measure Your Space In Four Easy Steps',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_1',
          string: 'Accurate measurements will ensure a perfect fit for your new dishwasher. You\'ll need a tape measure and be ready to take notes.'
        }
      },
      {
        image: {
          id: 'image_1',
          src: DISHWASHER_ANIMATIONS.FOUR_EASY_STEPS,
          alt: 'Four Easy Steps',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_0',
          strings: [
            'You\'re not measuring your old dishwasher. Focus on the space it will be installed and clear a path for delivery.'
          ]
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_2',
          string: 'Need help measuring? Please call your local store for more information.'
        }
      }
    ],
    footer: 'Next'
  },
  // Page 2
  {
    header: 'Step 1 of 4',
    sections: [
      {
        text: {
          id: 'text_3',
          string: 'Map Your Delivery Path',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_4',
          string: 'We want delivery and installation to go easy for you.'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        text: {
          id: 'text_5',
          string: 'Our experts suggest:'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        list: {
          id: 'list_0',
          items: [
            'Find a route with the least obstacles from the delivery truck to the installation location.',
            'Measure your front door, interiors doors, hallways and tight spaces along this path.',
            'Take note of the narrowest gap and tight turns.'
          ]
        }
      },
      {
        image: {
          id: 'image_2',
          src: DISHWASHER_ANIMATIONS.DELIVERY_PATH,
          alt: 'Delivery Path',
          size: '100%'
        }
      },
      {
        text: {
          id: 'text_6',
          string: 'This will help you know if your dishwasher will clear the delivery path.'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        tip: {
          id: 'tip_1',
          strings: [
            'Consider removing doors if necessary prior to the delivery. Be prepared to remove furniture, decor and rugs along the path on delivery day.'
          ]
        },
        modifiers: {
          hasBorder: true
        }
      },
    ],
    footer: 'Next'
  },
  // Page 3
  {
    header: 'Step 2 of 4',
    subHeader: 'Measure the Width',
    sections: [
      {
        text: {
          id: 'text_7',
          string: 'Measure the Width',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_8',
          string: 'In the space where your dishwasher will go, take note of the width in two places:'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        list: {
          id: 'list_1',
          items: [
            'at the top of the wall or cabinet',
            'at the floor level of the wall or cabinet',
          ]
        },
      },
      {
        text: {
          id: 'text_9',
          string: 'Use the smallest measurement of the two.'
        }
      },
      {
        image: {
          id: 'image_3',
          src: DISHWASHER_ANIMATIONS.DISHWASHER_MEASURE_WIDTH,
          alt: 'Dishwasher Measure Width',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_2',
          strings: [
            'If installing near a wall, allow about a 2 inch gap between the wall and the dishwasher door.'
          ]
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_10',
          string: 'Standard dishwashers are 24 inches wide.',
          isTiny: true
        }
      }
    ],
    footer: 'Next'
  },
  // Page 4
  {
    header: 'Step 3 of 4',
    subHeader: 'Measure the Height',
    sections: [
      {
        text: {
          id: 'text_11',
          string: 'Measure the Height',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_12',
          string: 'Measure from the floor to the underside of your countertops. Take note of the width in two places:'
        }
      },
      {
        list: {
          id: 'list_3',
          items: [
            'floor to underside of right-side counter',
            'floor to underside of left-side counter',
          ]
        },
      },
      {
        text: {
          id: 'text_13',
          string: 'Use the shorter of these two measurements for the overall height needed.'
        },
        modifiers: {
          marginOverride: 6
        }
      },
      {
        image: {
          id: 'image_4',
          src: DISHWASHER_ANIMATIONS.DISHWASHER_MEASURE_HEIGHT,
          alt: 'Dishwasher Measure Height',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_4',
          strings: [
            'Most dishwashers have adjustable legs, so you bring the appliance level with the countertop.'
          ],
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_14',
          string: 'Standard dishwashers are around 35 inches high.',
          isTiny: true
        }
      }
    ],
    footer: 'Next'
  },
  // Page 5
  {
    header: 'Step 4 of 4',
    subHeader: 'Measure the Depth',
    sections: [
      {
        text: {
          id: 'text_15',
          string: 'Decide on Depth',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_16',
          string: 'Measure the depth from the back wall to the front edge of your counters.'
        }
      },
      {
        text: {
          id: 'text_17',
          string: 'Note that a closed dishwasher door will sometimes still extend past your cabinets.'
        }
      },
      {
        image: {
          id: 'image_5',
          src: DISHWASHER_ANIMATIONS.DISHWASHER_MEASURE_DEPTH,
          alt: 'Dishwasher Measure Depth',
          size: '100%'
        }
      },
      {
        text: {
          id: 'text_18',
          string: 'Allow 21 to 27 inches of space in front of your dishwasher to fully open the door and easily load or remove items.'
        }
      },
      {
        text: {
          id: 'text_19',
          string: 'Verify exact dimensions with your model\'s manufacturer.'
        }
      },
      {
        image: {
          id: 'image_5',
          src: DISHWASHER_ANIMATIONS.DISHWASHER_DOOR_CHECK,
          alt: 'Dishwasher Door Check',
          size: '100%'
        }
      },
      {
        text: {
          id: 'text_20',
          string: 'Standard dishwashers are around 24 inches deep.',
          isTiny: true
        }
      },
      {
        text: {
          id: 'text_21',
          string: 'For a more detailed measuring guide visit ',
          linkString: 'How to Measure a Dishwasher.',
          linkUrl: 'https://www.homedepot.com/c/ah/how-to-measure-a-dishwasher/9ba683603be9fa5395fab901bbff5948'
        }
      },
    ],
    footer: 'Done'
  }
];